import { render, staticRenderFns } from "./WrhousCodeRegistration.vue?vue&type=template&id=79af36fe&scoped=true&"
import script from "./WrhousCodeRegistration.vue?vue&type=script&lang=js&"
export * from "./WrhousCodeRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af36fe",
  null
  
)

export default component.exports